import React from 'react';

const Alyx = () => (
    <svg
        width="186"
        height="186"
        viewBox="0 0 186 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="93" cy="93" r="93" fill="#84C5B8" />
        <mask id="mask0_55_4785" maskUnits="userSpaceOnUse" x="0" y="0" width="186" height="186">
            <circle cx="93" cy="93" r="93" fill="#A4DFD6" />
        </mask>
        <g mask="url(#mask0_55_4785)">
            <path
                d="M134.336 108.978C134.336 108.978 161.115 126.928 169.73 99.7683C169.856 99.3475 169.723 98.892 169.39 98.6049C168.345 97.7505 167.02 97.316 165.672 97.3861C165.672 97.3861 153.899 98.8819 141.781 86.4309L134.336 108.978Z"
                fill="#47280F"
            />
            <path
                d="M141.379 94.4353C141.379 94.4353 156.295 105.287 165.616 101.305C165.616 101.305 157.48 119.58 142.037 108.77L141.379 94.4353Z"
                fill="#FC9AA0"
            />
            <path
                opacity="0.13"
                d="M160.18 102.136C151.413 101.706 141.379 94.4353 141.379 94.4353L141.885 105.058C146.725 107.51 154.876 109.926 160.18 102.136Z"
                fill="black"
            />
            <path
                d="M141.926 136.677C141.926 136.677 157.563 108.285 139.482 88.8953L132.093 99.6497L141.926 136.677Z"
                fill="#6A3810"
            />
            <path
                d="M124.087 101.908L132.397 99.9065C132.397 99.9065 143.276 112.614 141.926 136.678L137.923 135.888C135.965 135.498 134.532 133.812 134.461 131.817C134.232 125.889 132.681 113.175 124.087 101.908Z"
                fill="#47280F"
            />
            <path
                d="M76.5688 133.215V148.769L90.3771 160.957L105.286 150.583V133.215H76.5688Z"
                fill="#E9784E"
            />
            <path
                d="M105.286 136.622V133.215H76.5688V148.769L81.5686 153.187L105.286 136.622Z"
                fill="#8E5234"
            />
            <path
                d="M75.3083 144.677L64.8309 155.756L90.9102 187.057L117.343 156.13L107.26 145.681C107.26 145.681 95.6745 158.561 90.924 160.223C90.924 160.223 78.0783 149.725 75.3083 144.677Z"
                fill="#214ED0"
            />
            <path
                d="M116.089 154.849C111.013 158.138 104.608 168.276 104.608 168.276C100.82 159.966 93.6248 161.967 93.6248 161.967C98.8392 165.063 101.762 170.139 103.05 172.902L117.356 156.164L116.089 154.849Z"
                fill="#0F2BB8"
            />
            <path
                d="M78.9854 169.037L65.9527 154.613L64.8447 155.783L80.5919 174.688C81.5719 169.324 84.9876 164.718 89.8367 162.223C89.8367 162.223 84.1583 158.837 78.9854 169.037Z"
                fill="#0F2BB8"
            />
            <path
                d="M36.9513 194.155H57.6568C57.6568 194.155 54.499 173.581 51.3482 170.174L36.9513 194.155Z"
                fill="#214ED0"
            />
            <path d="M132.377 172.064L121.775 194.154H144.745L132.377 172.064Z" fill="#214ED0" />
            <path
                d="M57.6567 194.154H121.775L132.377 172.064C132.377 172.064 121.394 160.43 114.455 159.529L90.9102 187.056L67.1023 158.491C67.1023 158.491 53.7026 166.24 51.3412 170.173L57.6567 194.154Z"
                fill="#1BA682"
            />
            <path
                d="M86.6306 194.154H93.4378L121.304 162.59C118.921 161.018 116.512 159.82 114.448 159.557L90.9032 187.084L67.1023 158.491C67.1023 158.491 65.6411 159.336 63.5983 160.61L86.6306 194.154Z"
                fill="#2CC7A3"
            />
            <path
                d="M117.55 194.154H121.795L132.398 172.064C132.398 172.064 131.179 170.769 129.295 169.017C126.2 174.121 120.32 184.619 117.55 194.154Z"
                fill="#2CC7A3"
            />
            <path
                d="M57.6565 194.155H61.5899C59.4639 179.301 56.4793 171.302 54.2841 167.147C53.1598 168.012 52.1722 169.042 51.3549 170.201L57.6565 194.155Z"
                fill="#2CC7A3"
            />
            <path
                d="M52.9825 52.0618C52.9825 52.0618 37.1868 67.4282 39.936 86.6171C39.936 86.6171 39.0219 97.4754 31.6815 98.7357C31.6815 98.7357 39.2019 100.377 42.3181 96.589C42.3181 96.589 37.5469 107.191 47.6365 111.99C47.6365 111.99 45.2682 104.144 54.2498 102.891L52.9825 52.0618Z"
                fill="#47280F"
            />
            <path
                d="M100.723 31.3219C100.723 31.3219 135.701 16.4194 140.569 63.869C140.569 63.869 139.302 84.5538 140.818 85.4609C140.818 85.4609 134.883 102.773 127.772 103.403C127.772 103.438 123.533 45.3172 100.723 31.3219Z"
                fill="#47280F"
            />
            <path
                d="M92.1151 41.3838L90.3769 40.5874L88.6388 41.3838L52.9824 57.7751V96.5546C60.2812 138.991 83.7844 140.182 90.3769 139.69C96.9695 140.209 120.473 138.997 127.772 96.5546V57.7751L92.1151 41.3838Z"
                fill="#E9784D"
            />
            <path
                d="M120.646 98.4871C114.801 98.4871 110.064 105.211 110.064 113.5C110.064 119.47 112.516 124.622 116.068 127.045C120.41 121.332 124.295 113.119 126.85 101.347C125.262 99.5833 123.019 98.5493 120.646 98.4871Z"
                fill="#EB5B31"
            />
            <path
                d="M60.0736 98.4871C57.7244 98.5475 55.5014 99.5628 53.9173 101.299C56.4657 113.071 60.3506 121.305 64.6856 127.025C68.2173 124.594 70.6548 119.456 70.6548 113.507C70.6341 105.211 65.8974 98.4871 60.0736 98.4871Z"
                fill="#EB5B31"
            />
            <path
                d="M99.5455 77.7812V80.6827C99.5455 80.6827 108.763 78.7922 121.255 82.4486L120.632 80.1149C120.632 80.1149 110.064 77.3518 99.5455 77.7812Z"
                fill="#47280F"
            />
            <path
                d="M60.683 84.2839C60.683 84.2839 71.1534 81.0015 81.1323 83.1482L80.1212 80.3782C80.1212 80.3782 71.652 79.1179 60.0389 82.338L60.683 84.2839Z"
                fill="#47280F"
            />
            <path
                d="M83.1473 116.153C83.1473 116.153 86.679 114.719 87.8147 118.23H93.1192C93.1192 118.23 94.3796 114.705 97.662 115.876L96.0208 113.514H84.4146L83.1473 116.153Z"
                fill="#A05535"
            />
            <path
                d="M139.191 84.2837L140.576 83.335L141.725 84.2837C141.725 84.2837 144.024 85.5925 142.937 87.5522C142.937 87.5522 135.147 98.1612 130.625 100.301V98.7291C130.625 98.7291 140.562 87.5869 140.562 85.4332L139.191 84.2837Z"
                fill="#4252BB"
            />
            <path
                d="M105.286 31.3218C105.286 31.3218 70.6132 10.3392 48.9936 56.57C48.9936 56.57 38.9594 101.908 59.3325 118.105C59.3325 118.105 52.4076 88.6255 65.7173 67.2136C65.7173 67.2136 76.9703 68.4324 87.6139 59.5962C87.6139 59.5962 76.4163 70.8284 69.3667 72.3242C69.3667 72.3242 86.0973 77.5387 105.259 50.4692L105.286 31.3218Z"
                fill="#47280F"
            />
            <path
                d="M113.942 53.8279L103.063 46.5291H77.2195L66.3058 53.8279C90.6747 64.7139 84.4768 113.5 84.4768 113.5H95.7714C95.7714 113.5 89.5736 64.7208 113.942 53.8279Z"
                fill="#D46439"
            />
            <path
                d="M129.004 118.105C129.004 118.105 126.442 110.114 129.267 103.424C130.601 100.358 131.532 97.1318 132.037 93.8264C134.42 77.1027 137.12 35.2069 105.307 31.322V50.4833C105.307 50.4833 125.687 66.6045 122.343 86.3752C122.315 86.3752 115.625 120.335 129.004 118.105Z"
                fill="#6A3810"
            />
            <path
                d="M69.3945 72.3383C69.3945 72.3383 86.1251 77.5527 105.286 50.4832V37.3743C101.478 36.8065 46.1613 29.8123 50.4617 105.488C52.4284 110.46 55.3092 114.864 59.3602 118.105C59.3602 118.105 52.4353 88.6257 65.745 67.2138C65.745 67.2138 76.998 68.4326 87.6416 59.5964C87.6416 59.6102 76.444 70.8425 69.3945 72.3383Z"
                fill="#6A3810"
            />
            <path
                d="M105.286 43.752V37.3741C105.286 37.3741 60.7659 23.8705 47.6847 64.5129C46.6313 72.112 46.3205 79.7957 46.7567 87.4552C53.3285 72.8089 72.4344 38.4682 105.286 43.752Z"
                fill="#6A3810"
            />
            <path
                d="M116.165 94.38C116.165 88.8054 112.447 84.2834 107.855 84.2834C103.264 84.2834 99.5456 88.8054 99.5456 94.38C99.5233 96.7101 100.214 98.9912 101.526 100.917H114.171C115.488 98.9928 116.184 96.7115 116.165 94.38Z"
                fill="white"
            />
            <circle cx="107.461" cy="96.8663" r="4.14803" fill="black" />
            <path
                d="M80.2112 94.38C80.2112 88.8054 76.4925 84.2834 71.9013 84.2834C67.31 84.2834 63.5914 88.8054 63.5914 94.38C63.5813 96.7145 64.287 98.996 65.6134 100.917H78.2306C79.5423 98.9912 80.2334 96.7101 80.2112 94.38Z"
                fill="white"
            />
            <circle cx="71.4996" cy="96.8663" r="4.14803" fill="black" />
            <path
                d="M77.095 122.586C85.563 124.922 94.5055 124.922 102.973 122.586C102.277 124.638 101.057 126.474 99.4348 127.911C95.6863 131.303 90.2123 131.979 85.7512 129.601C82.4671 127.802 79.5347 125.426 77.095 122.586Z"
                fill="#DE3F3B"
            />
            <path
                d="M77.095 122.586C77.095 122.586 91.2288 129.781 102.973 122.586C102.973 122.586 94.5181 121.831 92.2468 123.092C92.2398 123.092 90.0931 122.08 77.095 122.586Z"
                fill="#BC3535"
            />
        </g>
    </svg>
);

export default Alyx;
